import 'hammerjs'
import { NgModule, APP_ID, Inject } from '@angular/core';
// import { HttpModule, JsonpModule } from '@angular/http';
// import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Title } from '@angular/platform-browser';
import { FormsModule }    from '@angular/forms';
import { CommonModule } from '@angular/common';
// import { MaterialModule } from './components/material.module';

// Our Root Component
import { AppComponent } from './app.component';
//Custom Modules
import { LayoutsModule } from './layouts/layouts.module';
import { PagesModule } from './pages/pages.module';
import { ComponentsModule } from './components/components.module';

//ngrx modules
// import { StoreModule } from '@ngrx/store';
// import { EffectsModule } from '@ngrx/effects';
// import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { AppRoutingModule }     from './app-routing.module';

//import { CollectionEffects } from './effects/collection';
import { reducers } from './reducers/index';
//import { schema } from './db';

// Our Root routing & routingProviders

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  imports: [
    // Standard imports
    CommonModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutsModule,
    PagesModule,
    ComponentsModule

  ],
  providers: []
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts